import React from "react";
import { FormControlLabel, Checkbox } from "@mui/material";
import CommonButtons from "src/shared/components/CommonButtons";
import { ToastContainer } from "react-toastify";
import { useUserTheme } from "src/shared/utils/useUserTheme";

interface CustomerToolbarProps {
  searchTerm: string;
  showDeleted: boolean;
  onSearchChange: (term: string) => void;
  onToggleDeleted: () => void;
  onAddCustomer: () => void;
}

const CustomerToolbar: React.FC<CustomerToolbarProps> = ({ searchTerm, showDeleted, onSearchChange, onToggleDeleted, onAddCustomer }) => {
  const { fontClass, borderHighlight } = useUserTheme();

  return (
    <div className="customer-toolbar flex items-center justify-end gap-4 p-2">
      <FormControlLabel control={<Checkbox checked={showDeleted} onChange={onToggleDeleted} />} label="View deleted customers" />
      <input
        name="Customer search"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search by Name or Phone number"
        className={`w-full max-w-[350px] px-3 py-2.5 border rounded-md focus:outline-none focus:ring-2 ${borderHighlight} ${fontClass} text-sm text-black`}
      />
      <CommonButtons className="w-44 h-10" label="ADD CUSTOMER" onClick={onAddCustomer} />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnHover />
    </div>
  );
};

export default CustomerToolbar;
